import { AuthErrorFallback } from '@/app/guards/AuthErrorFallback';
import { Loader } from '@/view/shared/Loader';
import { setRedirectAfterLogin, useLogtoStarting } from '@/viewmodel/features/user';
import {
  selectIsError,
  selectIsLoaded,
  selectIsLoading,
  selectUserNotExistInDB,
} from '@/viewmodel/features/user';
import { useLogto } from '@logto/react';
import type { ReactNode } from 'react';
import { useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';

interface ProtectedRouteUserProps {
  children: ReactNode;
  needToExist: boolean;
}

export const ProtectedRouteUser = ({ children, needToExist }: ProtectedRouteUserProps) => {
  const isLoading = useSelector(selectIsLoading);
  const isError = useSelector(selectIsError);
  const isLoaded = useSelector(selectIsLoaded);
  const userNotExistInDB = useSelector(selectUserNotExistInDB);
  const { isAuthenticated } = useLogto();
  const isLogtoStarting = useLogtoStarting();
  const location = useLocation();

  if (isLogtoStarting) {
    return <Loader />;
  }

  if (!isAuthenticated) {
    setRedirectAfterLogin(location.pathname + location.search);
    return <Navigate to="/" replace />;
  }

  if (isError) {
    return <AuthErrorFallback />;
  }

  const isStableState = !isLoading && isLoaded;

  if (!isStableState) return <Loader />;

  if (needToExist && userNotExistInDB) return <Navigate to="/register" replace />;

  if (!needToExist && !userNotExistInDB) return <Navigate to="/workspaces" replace />;

  return <>{children}</>;
};
